const devUploadUrl = {
  uploadUrl: 'http://10.201.5.142:8080/file/upload/file',
  uploadImg: 'http://10.201.5.142:8080/file/upload/img'
}
const urlEnums = {
  dev: { // 开发联调环境
    baseUrl: 'https://apitest.kiscloud.net',
    uploadFile: 'http://10.100.10.49:8102/file/upload/learning',
    ...devUploadUrl
  },
  rc: { // rc环境
    baseUrl: 'https://apirc.kiscloud.net',
    uploadFile: 'http://10.100.50.89:8102/file/upload/learning',
    ...devUploadUrl
  },
  rc3: { // rc3环境
    baseUrl: 'https://apirc3.kiscloud.net',
    uploadFile: 'https://apirc3.kiscloud.net/file/upload/learning',
    ...devUploadUrl
  },
  prod: { // 线上生产环境
    baseUrl: 'https://api.kiscloud.net',
    uploadUrl: 'http://ty-api.kiscloud.net/file/upload/file',
    uploadImg: 'http://ty-api.kiscloud.net/file/upload/img',
    uploadFile: 'http://uploadfile.kiscloud.net/file/upload/learning'
  }
}
export default {
  ...urlEnums[process.env.NODE_BUILD],
  title: '调查问卷',
  cookieExpires: 1,
  homeName: '_home',
  appId: '7c04e317-28ba-47af-b5d5-f9d2ae1de8b8'
}
